import React from 'react';

import classNames from 'classnames/bind';
import style from './IndexSpreader.scss';
const ctx = classNames.bind(style);

import Spreader from '../Spreader';

const IndexSpreader = props => (
  <Spreader>
    <div className={ctx('inner')}>{props.children}</div>
  </Spreader>
);

export default IndexSpreader;
